/* eslint-disable */
import { Box, styled, Card, useTheme, Typography, Grid } from "@mui/material";
import TableImage from "../../Images/TableDummyImage.png";

const BoxWrapper = styled(Box)(({ theme }) => ({
  "& .ContentWrapper": {
    "& h2": {
      color: theme.palette.text.primary,
      fontSize: "24px",
      fontWeight: 700,
      lineHeight: "1",
      marginBottom: "18px",
    },
    "& p": {
      color: theme.palette.text.primary,
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "23px",
      marginBottom: "20px",
    },
    "& ul": {
      paddingLeft: "24px",
      "& li": {
        color: theme.palette.text.primary,
        fontSize: "16px",
        fontWeight: 400,
        lineHeight: "24px",
        marginBottom: "12px",
        "&:last-of-type": {
          marginBottom: "0",
        },
        "& span": {
          color: theme.palette.text.primary,
          fontSize: "16px",
          fontWeight: 700,
          lineHeight: "1",
        },
      },
    },
  },
  "& .ImgWrapper": {
    textAlign: "center",
    "& img": { width: "100%", maxWidth: "540px" },
  },
}));
function ResearchIntro() {
  const theme = useTheme();
  return (
    <BoxWrapper>
      <Card sx={{ padding: { xs: "20px 20px 20px 20px", sm: "38px 45px 38px 45px" }, border: `1px solid ${theme.palette.divider}`, boxShadow: "none !important" }}>
        <Grid container spacing={{ xs: 0, sm: 3 }} sx={{ alignItems: "center" }}>
          <Grid item xs={12} md={6}>
            <Box className="ContentWrapper">
              <Typography component="h2">Keyword discovery tool</Typography>
              <Typography component="p">
                Our Keyword Research Tool helps you uncover valuable search terms that drive traffic to your website. By identifying high-volume keywords, you can optimize your
                content strategy for better visibility and engagement.
              </Typography>
              <Typography component="ul">
                <Typography component="li">
                  <Typography component="span">Detailed Keyword Metrics</Typography> - Refine your SEO with essential keyword data like Search Volume, Keyword Difficulty, and CPC
                  insights to enhance both organic and paid campaigns.
                </Typography>
                <Typography component="li">
                  <Typography component="span">Long-Tail Keyword Identification</Typography> - Discover specific, low-competition long-tail keywords that drive high intent and
                  conversions, helping your content target the right audience.
                </Typography>
                <Typography component="li">
                  <Typography component="span">Competitor Analysis</Typography> - Analyze competitors’ keyword strategies to uncover gaps and opportunities for outperforming them.
                </Typography>
                <Typography component="li">
                  <Typography component="span">Trending Keywords in Real-Time</Typography> - Stay relevant by monitoring real-time trending keywords and adjusting to your
                  audience's evolving search patterns.
                </Typography>
                <Typography component="li">
                  <Typography component="span">Local Keyword Research</Typography> - Target local audiences with location-specific keyword suggestions tailored to your business
                  needs.
                </Typography>
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box className="ImgWrapper">
              <Typography component="img" src={TableImage} alt="Image" />
            </Box>
          </Grid>
        </Grid>
      </Card>
    </BoxWrapper>
  );
}

export default ResearchIntro;
